import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SelectFormField } from '@/components/form'
import { useStateOptions } from '@/hooks'
import { Building } from '@/reducers/types'

import { isCanadaCountry } from '../../../places.utils'
import { PlaceGeneralFormData } from './general-tab.constants'

interface GeneralStateFieldProps {
  building: Building
}

export const GeneralStateField = ({ building }: GeneralStateFieldProps) => {
  const { t } = useTranslation(['organisation'])
  const { setValue } = useFormContext<PlaceGeneralFormData>()
  const stateOptions = useStateOptions(building.country, building.state)

  return (
    <SelectFormField<PlaceGeneralFormData, string>
      searchable
      name="state"
      options={stateOptions}
      placeholder={t(
        isCanadaCountry(building.country)
          ? 'organisation:places.building.fields.state.placeholderCA'
          : 'organisation:places.building.fields.state.placeholder',
      )}
      size="small"
      type="single"
      onReset={() => setValue('state', '', { shouldDirty: true })}
    />
  )
}
